<template>
  <div v-cloak v-show="show" id="desktop" class="w-full h-full text-white">
    <div class="container mx-auto px-4 py-10 text-center min-h-[100vh] flex flex-col items-center justify-evenly">
      <div class="relative w-full">
        <h1 class="text-3xl leading-[1.25]">Dostęp do konkursu został zablokowany.</h1>
        <p class="text-xl mt-5">Skontaktuj się z administratorem konkursu.</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import {onBeforeMount, ref} from "vue";
import ApiHelper from "@/helpers/apiHelper.ts";
import axios from "axios";
import router from "@/router";

const show = ref(false);

onBeforeMount(async () => {
    router.push('/');
  try {
    const uninterceptedAxiosInstance = axios.create();
    const response = await uninterceptedAxiosInstance.get(ApiHelper.checkIp());

    if (response.status === 200 && response.data.status === "allowed") {
      router.push('/');
    } else {
      show.value = true;
      throw new Error("IP blocked (status not allowed)");
    }
  } catch (error) {
    show.value = true;
    // if (axios.isAxiosError(error) && error.response?.status === 403) {
    //   console.warn("Zablokowane IP - 403");
    // }
  }
});
</script>

<style scoped>
#desktop {
    background-image: url("../assets/images/backgrounds/bgTransparentPeopleMobile.webp");
    background-blend-mode: color-dodge;
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;
}

@media only screen and (min-width: 768px) {
    #desktop {
        background-image: url("../assets/images/backgrounds/bgTransparentPeople.webp");
    }
}

</style>